import { Translation } from '@teamhanko/hanko-elements';
import { de } from '@teamhanko/hanko-elements/i18n/de';
import { en } from '@teamhanko/hanko-elements/i18n/en';

export const availableHankoLanguages: Record<string, Translation> = { de, en };
